import React from 'react';
import useCountdown from 'Jsx/Shared/Hooks/useCountdown';

const CountdownText: React.FC<{
  banner: {
    message: string;
    alternativeShortMessage: string;
    handleClickOnCountdownBar?(): void;
    expirationDate: Date;
  };
}> = ({ banner: { expirationDate, message, alternativeShortMessage } }) => {
  const { rawDays, hours, minutes, finished, hasStarted } = useCountdown(
    expirationDate,
  );

  if (finished || !hasStarted) return null;

  return (
    <p className="font-subtitle3 text-left sm:text-center font-bold">
      {/* message */}
      <span className="text-left inline-flex font-caption sm:hidden text-white">
        {alternativeShortMessage}
      </span>
      <span className="hidden sm:inline-flex mr-8 text-white">{message}</span>
      {/* time left */}
      <span className="block font-caption sm:hidden text-yellow-main">
        {`${rawDays}d ${hours}h ${minutes}m`}
      </span>
      <span className="hidden sm:inline text-yellow-main">
        {`${rawDays}d ${hours}h ${minutes}m`}
      </span>
    </p>
  );
};

export default CountdownText;
